export const pendingSaveActions = {
  start: "PENDING_SAVE_START",
  finish: "PENDING_SAVE_FINISH",
  reset: "PENDING_SAVE_RESET"
};

export const startPendingSave = () => {
  return {
    type: pendingSaveActions.start
  };
};

export const finishPendingSave = () => {
  return {
    type: pendingSaveActions.finish
  };
};

export const resetPendingSaves = () => {
  return {
    type: pendingSaveActions.reset
  };
};
